import { Page } from "@/components";
import { useSelskaper } from "../selskap/SelskapContext";
import { SøkAndFjernAvtaleForm } from "./SøkAndFjernAvtaleForm";

export const FjernAvtalePage = () => {
  const { active } = useSelskaper();

  return (
    <Page withBackLink>
      {active?.organisasjonsnummer != null && (
        <SøkAndFjernAvtaleForm aktivLeverandør={active} />
      )}
    </Page>
  );
};
